<template>
	<MobileAppBanner ref="bannerRef" />
</template>

<script lang="ts" setup>
import { onMounted, ref } from "vue"
import MobileAppBanner from "@/components/MobileAppBanner.vue"
import { useMobileAppBanner } from "@/composables/common/useMobileAppBanner"

const bannerRef = ref<InstanceType<typeof MobileAppBanner> | null>(null)

const { setup } = useMobileAppBanner()

onMounted(() => {
	setup(
		() => {
			bannerRef.value?.open()
		},
		() => {
			bannerRef.value?.close()
		}
	)
})
</script>
